export const CONTRACT_TYPE = {
  FIXED: 'fixed',
  FIXED_UNITARY: 'fixed-unitary',
  NIGHTLY: 'nightly',
  FORTNIGHT: 'fortnight',
  MONTHLY: 'monthly'
};

export const AVAILABILITY_TYPE = {
  FIXED: {
    AVAILABLE: 'available',
    OCCUPIED: 'occupied'
  },
  STANDARD_UNITARY: {
    AVAILABLE: 'available',
    OCCUPIED: 'occupied'
  },
  STANDARD: {
    AVAILABLE: 'available',
    OCCUPIED: 'occupied'
  }
};

export const HALF_QUARTER_TYPE = {
  '2': 'three-quarters',
  '1': 'halfs',
  '0': 'quarters'
};

export const HALF_QUARTER_LAST_TYPE = {
  '0': 'three-quarters three-quarters-last',
  '1': 'halfs halfs-last',
  '2': 'quarters quarters-last'
};
